"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getState = getState;
exports.default = void 0;

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-env browser */
const loadScript = async (_ref) => {
  let {
    scriptsRegistry,
    onLoad,
    onError,
    children
  } = _ref,
      props = _objectWithoutProperties(_ref, ["scriptsRegistry", "onLoad", "onError", "children"]);

  const {
    src
  } = props;

  if (scriptsRegistry) {
    scriptsRegistry.results[src] = {
      error: undefined
    };
    scriptsRegistry.scripts.push(props);
    return;
  }

  if (typeof document === 'undefined') {
    throw new Error('you must pass a scriptsRegistry if calling on the server side');
  }

  if (typeof document.querySelector === 'function') {
    if (document.querySelector(`script[src="${src}"]`)) {
      results[src] = {
        error: undefined
      };
      return;
    }
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    Object.keys(props).forEach(key => script.setAttribute(key, props[key]));
    script.onload = resolve;
    script.onerror = reject;
    if (document.body) document.body.appendChild(script);
  });
};

const results = {};
const promises = {};

var _default = props => {
  const {
    scriptsRegistry
  } = props;

  const _promises = scriptsRegistry ? scriptsRegistry.promises : promises;

  const _results = scriptsRegistry ? scriptsRegistry.results : results;

  return _promises[props.src] || (_promises[props.src] = loadScript(props).then(() => _results[props.src] = {
    error: null
  }, (error = new Error(`failed to load ${props.src}`)) => {
    _results[props.src] = {
      error
    };
    throw error;
  }));
};

exports.default = _default;

function getState({
  src,
  scriptsRegistry
}) {
  const result = scriptsRegistry ? scriptsRegistry.results[src] : results[src];
  const promise = scriptsRegistry ? scriptsRegistry.promises[src] : promises[src];
  return {
    loading: result == null,
    loaded: result ? !result.error : false,
    error: result && result.error,
    promise
  };
}